import styled from 'styled-components';
import { Form } from '@unform/web';

export const Conteiner = styled.div`
  display: flex;
  flex-direction: column;

  width: 95%;
`;

export const ConteinerFiltro = styled.div`
  display: flex;

  width: 300px;
  margin-bottom: 5px;
  margin-right: 5px;
`;

export const TabelaPrincipal = styled.table`
  width: 100%;
  padding: 5px;

  border-collapse: collapse;
`;

export const LinhaCabecalhoTabela = styled.tr`
  height: 50px;

  background-color: ${(props) => props.theme.PRIMARY};
`;

export const CabecalhoTabela = styled.th`
  width: ${(props) => props.$largura};

  color: white;

  font-size: 1.125rem;
  font-weight: unset;
  line-height: 1.2;

  &:nth-child(1) {
    padding-left: 10px;

    border-top-left-radius: 15px;
  }
  &:nth-last-child(1) {
    border-top-right-radius: 15px;
  }
`;

export const LinhaCorpoTabela = styled.tr`
  height: 60px;

  color: darkslategray;

  font-size: 1.125rem;
  font-weight: unset;

  &:nth-child(even) {
    background-color: #f9f9f9;
  }
  &:nth-child(odd) {
    background-color: #fcfcfc;
  }
  &:hover {
    color: #555;
    background-color: #f4f4f4;
  }
`;

export const Td = styled.td`
  &:nth-child(1) {
    padding-left: 20px;
  }
  &:nth-last-child(1) {
    padding-right: 5px;
  }
`;

export const ConteinerAcoes = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$header ? 'flex-start' : 'center')};

  flex-wrap: wrap;
`;

export const ConteinerPaginacao = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 50px;
  padding: 0px 20px;

  color: white;
  background-color: ${(props) => props.theme.PRIMARY};
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

export const TextoPaginacao = styled.div``;

export const AcoesPaginacao = styled.div`
  display: flex;
`;

export const BotaoPaginacao = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 30px;
  height: 30px;

  color: ${(props) => props.theme.LIGHT};
  background-color: ${(props) => props.theme.PRIMARY};
  border: none;
  border-radius: 15px;

  transition: ease 100ms;

  &:focus {
    outline: 0;
  }

  &:hover {
    color: ${(props) => props.theme.PRIMARY};
    background-color: ${(props) => props.theme.LIGHT};
  }
`;

export const AreaSuperior = styled.div`
  display: flex;
  justify-content: space-between;

  margin-bottom: 15px;
`;

export const FormFiltro = styled(Form)`
  display: flex;
  align-items: flex-end;

  width: 100%;
  padding-top: 10px;
`;
